import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaEye,
  FaSitemap,
  FaRegCommentAlt,
  FaRegEnvelope,
  FaMapMarkerAlt,
  FaMapPin,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaRegUser,
} from "react-icons/fa";
import { Rating } from "react-simple-star-rating";
import { BsDot, BsFillShareFill, BsTelephone } from "react-icons/bs";
import Footer from "../../molecules/Footer/Footer";
import "./AgentSingle.css";
import Foot from "../../molecules/Foot/Foot";
import prof from "../../../images/agency/agent/5.jpg";



const AgentSingle = () => {
  const [rating, setRating] = useState(0);

  const handleRating = (rate: number) => {
    setRating(rate);
    // other logic
  };
  const decor = {
    textDecoration: "none",
  };

  return (
    <div className="listing-wrapper">
      <div className="listing-container">
        <div className="listing-heading">
          <div className="inner">
            <h4>Agent Page</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut nec
              tincidunt arcu, sit amet fermentum sem.
            </p>
          </div>
        </div>
        <div className="wrap-mini">
          <div className="list-starter">
            <div className="home-list">
              <div className="dot">
                <Link style={decor} to="/">
                  <li className="home">Home</li>
                </Link>{" "}
                <BsDot className="dotted-icon" />
              </div>
              <div className="dot">
                <Link style={decor} to="/agentsingle">
                  <li className="home">Agent Single</li>
                </Link>{" "}
                <BsDot className="dotted-icon" />
              </div>
            </div>
            <div className="share">
              <BsFillShareFill className="share-icon" />
              <p className="share-text">Share</p>
            </div>
          </div>
        </div>
        <div className="home-bg">
          <div className="sing-content">
            <div className="sing-edit-content-wrapper">
              <div className="sing-box sing-box1">
                <div className="sing-content1">
                  <div className="sing-inner">
                    <div className="sing-img">
                      <img src={prof} alt="" />
                    </div>
                    <div className="sing-inner-wrap">
                      <div className="sing-inner1">
                        <h2>Andy Sposty</h2>
                        <div className="sing-rate">
                          <h3>Mavers RealEstate Agency</h3>
                          <div className="sing-rating">
                            <Rating
                              className="rating"
                              size={15}
                              onClick={handleRating}
                              ratingValue={rating} /* Available Props */
                            />
                          </div>
                        </div>
                        <div className="sing-star">
                          <div className="sing-star1">
                            <FaEye className="sing-icon" />
                            <p>Viewed- 154</p>
                          </div>
                          <div className="sing-star1">
                            <FaSitemap className="sing-icon" />
                            <p>Reviews- 154</p>
                          </div>
                          <div className="sing-star1">
                            <FaRegCommentAlt className="sing-icon" />
                            <p>Listings- 154</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sing-content2">
                  <h2>About This Agent</h2>
                  <p>
                    Vivamus vel lacus lacinia, condimentum nunc non, iaculis
                    diam. Proin in mollis augue, eget fermentum quam. Donec
                    semper purus ut ante tempus gravida. Quisque et ante orci.
                    Sed venenatis turpis mi, non varius justo scelerisque id.
                    Maecenas fermentum nunc sed maximus efficitur. Pellentesque
                    nec turpis viverra, cursus ex porta, porttitor odio. In
                    gravida ante nec eleifend commodo.
                    <p>
                      Cras gravida interdum nisl, vel venenatis nisl consectetur
                      ut. Duis in erat quis dui imperdiet pretium et eu purus.
                      Fusce purus ex, placerat et eros quis, lacinia tempor
                      ligula. Placerat in egestas erat imperdiet sed euismod.
                      Erat pellentesque adipiscing commodo elit at imperdiet dui
                      accumsan sit. Quam viverra orci sagittis eu volutpat odio
                      facilisis. Sit amet massa vitae tortor condimentum
                      lacinia. Lacus vestibulum sed arcu non odio. Sodales ut eu
                      sem integer vitae justo. Amet tellus cras adipiscing enim
                      eu turpis egestas.
                    </p>
                  </p>
                </div>
              </div>
              <div className="sing-box sing-box2">
                <div className="sing-box2-header">
                  <h3>Agent Contacts</h3>
                </div>
                <div className="sing-box2-content">
                  <div className="singg-box1">
                    <div className="inn">
                      <BsTelephone className="inn-icon" />
                      <p>Phone:</p>
                    </div>
                    <h3>+7(123)987654</h3>
                  </div>
                  <div className="singg-box1">
                    <div className="inn">
                      <FaRegEnvelope className="inn-icon" />
                      <p>Mail:</p>
                    </div>
                    <h3>MaversRealEstate@domain.com</h3>
                  </div>
                  <div className="singg-box1">
                    <div className="inn">
                      <FaMapMarkerAlt className="inn-icon" />
                      <p>Address:</p>
                    </div>
                    <h3>70 Bright St New York, USA</h3>
                  </div>
                  <div className="singg-box1">
                    <div className="inn">
                      <FaMapPin className="inn-icon" />
                      <p>Website:</p>
                    </div>
                    <h3>https://princewillnzube.com/</h3>
                  </div>
                </div>
                <div className="sing-footer">
                  <FaFacebookF className="sing-social" />
                  <FaInstagram className="sing-social" />
                  <FaTwitter className="sing-social" />
                </div>
              </div>
              <div className="sing-box sing-box3">
                <div className="sing-box2-header">
                  <h3>Get In Touch</h3>
                </div>
                <div className="edit3-info">
                  <div className="edit-info-wrap">
                    <label for="myfile">Your Name*</label>
                    <div className="input-style">
                      <div className="input-icon">
                        <FaRegUser className="userprofile" />
                      </div>
                      <input type="text" placeholder="First Name" />
                    </div>
                  </div>
                </div>
                <div className="edit3-info">
                  <div className="edit-info-wrap">
                    <label for="myfile">Your Mail*</label>
                    <div className="input-style">
                      <div className="input-icon">
                        <FaRegEnvelope className="userprofile" />
                      </div>
                      <input type="text" placeholder="Second Name" />
                    </div>
                  </div>
                </div>
                <div className="edit3-info">
                  <div className="edit-info-wrap">
                    <label for="myfile">Notes</label>
                    <div className="input-style">
                      <input className="about-me" type="text" />
                    </div>
                  </div>
                </div>
                <button className="save-changes">Send</button>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="inner-footer">
        <Footer />
      </div>
      <div className="mini-footer">
        <div className="mini-footerr">
          <Foot />
        </div>
      </div>
    </div>
  );
};

export default AgentSingle;
